import palette from "assets/theme/base/palette";

function collapseItem(theme, ownerState) {
  const { transitions } = theme;
  const { active } = ownerState;

  return {
    display: "flex",
    alignItems: "center",
    width: "calc(100% - 16px)",
    padding: "7px 10px",
    margin: "1px 8px",
    borderRadius: "10px",
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    background: active ? palette.white : "transparent",
    boxShadow: active ? "0 4px 16px rgba(0,0,0,0.14)" : "none",
    transition: transitions.create(["background", "box-shadow"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),

    "&:hover": {
      background: active ? palette.white : `rgba(255,255,255,0.15)`,
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const { transitions } = theme;
  const { active } = ownerState;

  return {
    minWidth: "28px",
    minHeight: "28px",
    color: `${active ? palette.brand[600] : palette.white} !important`,
    borderRadius: "8px",
    display: "grid",
    placeItems: "center",
    transition: transitions.create("color", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& svg, svg g, & .MuiIcon-root": {
      color: `${active ? palette.brand[600] : palette.white} !important`,
    },
  };
}

const collapseIcon = (theme, { active }) => ({
  color: active ? palette.brand[600] : palette.white,
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, active } = ownerState;
  const { size, fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(10),

    [breakpoints.up("xl")]: {
      opacity: miniSidenav ? 0 : 1,
      maxWidth: miniSidenav ? 0 : "100%",
      marginLeft: miniSidenav ? 0 : pxToRem(10),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: size.sm,
      lineHeight: 0,
      color: active ? palette.brand[700] : palette.white,
      transition: transitions.create("color", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },
  };
}

function collapseArrow(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { noCollapse, miniSidenav, open, active } = ownerState;
  const { size } = typography;
  const { pxToRem, rgba } = functions;

  return {
    fontSize: `${size.lg} !important`,
    fontWeight: 700,
    marginBottom: pxToRem(-1),
    transform: open ? "rotate(0)" : "rotate(-180deg)",
    color: active ? palette.brand[600] : rgba(palette.white, 0.6),
    transition: transitions.create(["color", "transform"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      display: noCollapse || miniSidenav ? "none !important" : "block !important",
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText, collapseArrow };
